import { interpolatePresentationAppearance, type PresentationAppearance } from '../../../renderer/src/presentation-appearance';
import type { TimedCinematicWaypoint } from './cinematic-timeline';
import { cinematicPropertyTimeline } from './cinematic-property-timeline';

export function cinematicTransitionAmount(item: TimedCinematicWaypoint, seconds: number): number {
  const raw = item.effectiveDurationSeconds === 0 ? 1 : Math.max(0, Math.min(1,
    (seconds - item.transitionStartSeconds) / item.effectiveDurationSeconds));
  return item.waypoint.transition.type === 'smooth' && item.waypoint.transition.easing === 'linear'
    ? raw : raw * raw * (3 - 2 * raw);
}

/** Uses the original film clock so trimming retains an appearance transition at IN. */
export function cinematicAppearance(base: PresentationAppearance, timeline: readonly TimedCinematicWaypoint[], seconds: number, filmDuration?: number): PresentationAppearance {
  let current = timeline.some(item => item.waypoint.overrides.presentationAppearance !== undefined)
    ? { plateTransparency: base.plateTransparency ?? 0, ...base } : base;
  const duration = filmDuration ?? Math.max(seconds, ...timeline.map(item => item.seconds + item.effectiveDurationSeconds));
  for (const item of cinematicPropertyTimeline(timeline, 'presentationAppearance', duration)) {
    if (seconds + 1e-9 < item.transitionStartSeconds) break;
    const next = { ...current, ...item.waypoint.overrides.presentationAppearance };
    const amount = cinematicTransitionAmount(item, seconds);
    if (amount < 1) return interpolatePresentationAppearance(current, next, amount);
    current = next;
  }
  return current;
}
